import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AutoLogin() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Accessing dashboard...');

  useEffect(() => {
    const performAutoLogin = async () => {
      const token = searchParams.get('token');
      const redirect = searchParams.get('redirect') || '/';

      if (!token) {
        setStatus('No token provided');
        window.location.href = '/login';
        return;
      }

      try {
        // IMPORTANT: Clear any existing session first
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('masquerade_mode');
        localStorage.removeItem('masquerade_client_name');
        delete axios.defaults.headers.common['Authorization'];
        
        // Small delay to ensure cleanup
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Set the new token
        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Verify token by calling /auth/me
        setStatus('Verifying access...');
        const response = await axios.get(`${API}/auth/me`);
        const user = response.data;
        
        // Store user info
        localStorage.setItem('user', JSON.stringify(user));

        // Detect masquerade (Support PIN) session and store banner info
        const masquerade = searchParams.get('masquerade');
        const cn = searchParams.get('cn');
        if (masquerade === '1') {
          localStorage.setItem('masquerade_mode', 'true');
          localStorage.setItem('masquerade_client_name', cn ? decodeURIComponent(cn) : (user.company_name || user.email));
        }
        
        console.log('Auto-login successful:', user.email, user.role);
        setStatus(`Welcome, ${user.company_name || user.email}! Redirecting...`);
        
        // Small delay to show success message
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Full page reload to ensure all contexts are reinitialized
        window.location.href = redirect;
        
      } catch (error) {
        console.error('Auto-login failed:', error);
        setStatus('Access denied. Redirecting to login...');
        
        // Clean up on failure
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete axios.defaults.headers.common['Authorization'];
        
        setTimeout(() => {
          window.location.href = '/login';
        }, 1500);
      }
    };

    performAutoLogin();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-slate-600">{status}</p>
      </div>
    </div>
  );
}
